module.exports = __webpack_public_path__ + "media/images/icons/vehicle-storage-medium-10x15-0926db41128a3bdc16734e6711b9bc46.png";